export default __webpack_public_path__ + "static/media/logo.ca639c18.svg";